// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1ofvU","dragIcon":"Choice_dragIcon__4-rV8","left":"Choice_left__12X5C","input":"Choice_input__3Iboj"};